import { BlocksIconStar } from 'blocks-nextjs/blocks-web-components/components/icon/icons/star';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconStar = createComponent({ react: React, tagName: 'cat-icon-star', elementClass: BlocksIconStar });
